import type { TemplatePreviewProductDto } from "./TemplatesForm.types";

export const TEMPLATE_MAX_LENGTH = 2000;
export const FALLBACK_MAX_LENGTH = 2000;
export const MAX_LENGTH_LIMIT = 10000;
export const PREVIEW_DEBOUNCE_MS = 400;

// Длина окружения плейсхолдера: `{{` + `}}`. Используется при вычислении
// диапазона подсветки unknown-переменных, когда бэк отдаёт только offset.
export const PLACEHOLDER_BRACES_LENGTH = 4;

export const CATEGORY_LABELS: Record<string, string> = {
  basic: "Основные",
  identifiers: "Идентификаторы",
  pricing: "Цены",
  logistics: "Логистика",
};

export const formatCategoryLabel = (key: string): string => {
  if (CATEGORY_LABELS[key]) return CATEGORY_LABELS[key];
  return key.charAt(0).toUpperCase() + key.slice(1);
};

export interface PreviewSample extends TemplatePreviewProductDto {
  displayLabel: string;
}

// Отдельный селектор payload-полей: displayLabel — только для UI, бэк его
// не ждёт и при `whitelist: true` в ValidationPipe вернёт 400.
export const toPreviewProduct = (
  sample: PreviewSample,
): TemplatePreviewProductDto => {
  const { displayLabel: _displayLabel, ...rest } = sample;
  void _displayLabel;
  return rest;
};

// Сэмплы для live-preview: 3 профиля товара — «полный», «без описания»,
// «бедный» (нет params). Так юзер сразу видит, как шаблон ведёт себя на
// проблемных товарах (missingVars, fallback).
export const PREVIEW_SAMPLES: PreviewSample[] = [
  {
    productId: 1001,
    displayLabel: "Полный товар",
    title: "Air Jordan 4 Retro",
    description: "",
    vendor: "Nike",
    seriesName: "Jordan 4",
    vendorCode: "FJ4188-100",
    barcode: "194955123456",
    countryOfOrigin: "Китай",
    gender: "Унисекс",
    saleDate: "2024",
    price: 12990,
    oldPrice: 14990,
    params: { Цвет: "Black", Размер: "42" },
    properties: { Материал: "Кожа" },
  },
  {
    productId: 1002,
    displayLabel: "Без описания",
    title: "Oversize Hoodie",
    description: "Удобная толстовка для повседневной носки.",
    vendor: "Adidas",
    vendorCode: "HC-2034",
    gender: "Унисекс",
    saleDate: "2023",
    price: 5990,
    params: { Размер: "L" },
    properties: { Материал: "Хлопок 80% / Полиэстер 20%" },
  },
  {
    productId: 1003,
    displayLabel: "Минимум данных",
    title: "Сумка спортивная",
    description: "",
    vendor: "Puma",
    vendorCode: "078-RED",
    price: 2490,
    oldPrice: 3490,
    countryOfOrigin: "Вьетнам",
    params: {},
    properties: {},
  },
];
